export const ORDER_DETAILS_WIDGET_TYPE_ID = 'OrderDetailsWidget';
